import ReportConcernModal from './report-concern-modal';

export default ReportConcernModal;
